import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import './index.less';

import Popup from './popup';

class PopupWindow extends PureComponent {
	constructor(props) {
		super(props);

		this.click = this.click.bind(this);
		this.close = this.close.bind(this);
	}

	click(payload) {
		const { popup, closePopup } = this.props;
		closePopup(popup.id, { is_clicked: true, payload });
	}

	close() {
		const { popup, closePopup } = this.props;
		closePopup(popup.id, { is_clicked: false });
	}

	render() {
		return (
			<div className='popup-window'>
				<Popup
					popup={this.props.popup}
					click={this.click}
					close={this.close}
				/>
			</div>
		);
	}
}

PopupWindow.propTypes = {
	popup: PropTypes.object.isRequired,
	closePopup: PropTypes.func.isRequired
};

export default PopupWindow;


// WEBPACK FOOTER //
// ./frontend/cabinets/modules/root/components/popup-window/index.js